// SupportVisitEnded.tsx · v12.10.10 (#1390 'Sign in as a … user instead' is a styled text link) · 2026-10-08 · VoiceSpectrum AI
// SupportVisitEnded.tsx · v12.10.9.4 (#1365 a support visit that the practice blocked or that timed out says so) · 2026-10-07 · VoiceSpectrum AI
// Shown instead of the sign-in page when this tab was a VoiceSpectrum Support visit (lib/supportVisit) and it ended without
// Leave: the practice blocked support access, or the visit reached its time limit. Link back to Support Ops / Platform Ops.
import { useState } from 'react';
import { takeSignedOutNotice } from '../lib/auth';
import { clearSupportVisit, type SupportVisit } from '../lib/supportVisit';

export default function SupportVisitEnded({ visit, onSignIn }: { visit: SupportVisit; onSignIn: () => void }) {
  const [reason] = useState(() => takeSignedOutNotice()?.reason ?? 'revoked');
  const timedOut = reason === 'idle' || reason === 'absolute';
  return (
    <div className="tenant-page" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: 16 }}>
      <section className="tenant-empty" style={{ textAlign: 'center', maxWidth: 460 }} data-testid="support-visit-ended">
        <h1>{timedOut ? `Your support visit to ${visit.name} has ended` : `${visit.name} ended this support visit`}</h1>
        <p>{timedOut ? 'It reached its time limit.' : 'The practice changed or blocked VoiceSpectrum Support access.'} To open the practice again, start a new visit from {visit.from}.</p>
        <p style={{ marginTop: 18 }}>
          <a className="btn btn-primary" href={visit.back} onClick={() => clearSupportVisit()}>Back to {visit.from}</a>
        </p>
        <p style={{ marginTop: 14 }}>
          <button type="button" className="btn-link" style={{ background: 'none', border: 0, padding: 0, font: 'inherit', fontWeight: 600, color: '#4f46e5', textDecoration: 'underline', textUnderlineOffset: 3, cursor: 'pointer' }} onClick={() => { clearSupportVisit(); onSignIn(); }}>Sign in as a {visit.name} user instead</button>
        </p>
      </section>
    </div>
  );
}
